const CATEGORIES = {
  CL_COOPERATING: '参加者を見るページ',
  MJ_LINE_BUTTON: 'mj_LINE_button',
  CL_DATING_EVENT: 'デーティング',
  CL_MATCHING_EVENT: 'マッチング体験',
  MJ_SHARE_BUTTON: 'MJ共有ボタン',
  PURCHASE_SUCCESS: 'チケット詳細経由参加者を見るページ',
  MJ_PURCHASE_BUTTON: 'チケット一覧',
  MJ_EVENT_BOOKMARK: '気になるリスト',
  QUESTIONNAIRE_REMINDER_MODAL: 'アンケートモーダル',
  MJ_TOP_PAGE_SHORTCUT_LINK: 'MJTOPすぐ行けるイベント',
  MJ_KONKATSU_TOP_PAGE_SHORTCUT_LINK: 'MJ婚活TOPすぐ行けるイベント',
  MJ_SEARCH_BUTTON: 'ヘッダーこの条件で探すボタンabtest',
  CL_DATING_EVENT_ENTER_APP_STORE: 'app_casual_footer',
  CL_DATING_EVENT_ENTER_RECENT_EVENT: '1on1_event_footer',
  TOP_FV_AB_TEST: 'TOPFV改修',
  EVENT_DETAIL_CAROUSEL_BANNER: 'event_detail_carousel_banner',
  FOOTER_TAB_AB_TEST: 'issue248',
  SEARCH_PAGE_AND_EVENT_DETAIL_PAGE_UI_AB_TEST: 'issue231',
  EVENT_TITLE_AB_TEST: 'issue268',
  REPEAT_DISCOUNT_ISSUE_333: '回数券issue333',
  REPEAT_DISCOUNT_ISSUE_333_MULTIPLE: '回数券issue333_複数',
  REPEAT_DISCOUNT_ISSUE_333_REFUND: '回数券issue333_返金'
}

export const ACTIONS = {
  CLICK: 'click',
  VIEW: 'view',
  PURCHASE: 'purchase',
  CANCEL: 'cancel',
  AB_GROUP_ALLOCATION: 'ab_group_allocation'
}

export const CL_COOPERATING_CLICK = { category: CATEGORIES.CL_COOPERATING, action: ACTIONS.CLICK }
export const CL_COOPERATING_VIEW = { category: CATEGORIES.CL_COOPERATING, action: ACTIONS.VIEW }
export const MJ_LINE_BUTTON_CLICK = { category: CATEGORIES.MJ_LINE_BUTTON, action: ACTIONS.CLICK }
export const CL_DATING_EVENT_CLICK = { category: CATEGORIES.CL_DATING_EVENT, action: ACTIONS.CLICK }
export const CL_DATING_EVENT_PURCHASE = { category: CATEGORIES.CL_DATING_EVENT, action: ACTIONS.PURCHASE }
export const CL_MATCHING_EVENT_CLICK = { category: CATEGORIES.CL_MATCHING_EVENT, action: ACTIONS.CLICK }
export const MJ_SHARE_BUTTON_CLICK = { category: CATEGORIES.MJ_SHARE_BUTTON, action: ACTIONS.CLICK }
export const MJ_PURCHASE_SUCCESS_CLICK = { category: CATEGORIES.PURCHASE_SUCCESS, action: ACTIONS.CLICK, label: '参加者を見るボタン' }
export const MJ_PURCHASE_BUTTON_CLICK = { category: CATEGORIES.MJ_PURCHASE_BUTTON, action: ACTIONS.CLICK }
export const MJ_EVENT_BOOKMARK_CLICK = { category: CATEGORIES.MJ_EVENT_BOOKMARK, action: ACTIONS.CLICK }
export const QUESTIONNAIRE_REMINDER_MODAL_CLICK = { category: CATEGORIES.QUESTIONNAIRE_REMINDER_MODAL, action: ACTIONS.CLICK }
export const MJ_TOP_PAGE_SHORTCUT_LINK_CLICK = { category: CATEGORIES.MJ_TOP_PAGE_SHORTCUT_LINK, action: ACTIONS.CLICK }
export const MJ_KONKATSU_TOP_PAGE_SHORTCUT_LINK_CLICK = { category: CATEGORIES.MJ_KONKATSU_TOP_PAGE_SHORTCUT_LINK, action: ACTIONS.CLICK }
export const MJ_SEARCH_BUTTON_CLICK = { category: CATEGORIES.MJ_SEARCH_BUTTON, action: ACTIONS.CLICK }
export const BOOKMARK_EVENTS_NOTIFICATION_MODAL_VIEW = { action: ACTIONS.VIEW }
export const BOOKMARK_EVENTS_NOTIFICATION_MODAL_CLICK = { action: ACTIONS.CLICK }
export const CL_DATING_EVENT_ENTER_APP_STORE_CLICK = {
  category: CATEGORIES.CL_DATING_EVENT_ENTER_APP_STORE,
  action: ACTIONS.CLICK,
  label: CATEGORIES.CL_DATING_EVENT_ENTER_APP_STORE
}
export const CL_DATING_EVENT_ENTER_RECENT_EVENT_CLICK = {
  category: CATEGORIES.CL_DATING_EVENT_ENTER_RECENT_EVENT,
  action: ACTIONS.CLICK,
  label: CATEGORIES.CL_DATING_EVENT_ENTER_RECENT_EVENT
}
export const EVENT_DETAIL_CAROUSEL_BANNER_VIEW = {
  category: CATEGORIES.EVENT_DETAIL_CAROUSEL_BANNER,
  action: ACTIONS.VIEW
}
export const AB_TEST_FOOTER_TAB_GROUP_ALLOCATION = {
  category: CATEGORIES.FOOTER_TAB_AB_TEST,
  action: ACTIONS.AB_GROUP_ALLOCATION
}
export const SEARCH_PAGE_AND_EVENT_DETAIL_PAGE_UI_AB_TEST_VIEW = {
  category: CATEGORIES.SEARCH_PAGE_AND_EVENT_DETAIL_PAGE_UI_AB_TEST,
  action: ACTIONS.VIEW
}
export const TOP_FV_AB_TEST_VIEW = {
  category: CATEGORIES.TOP_FV_AB_TEST,
  action: ACTIONS.VIEW
}
export const TOP_FV_AB_TEST_CLICK = {
  category: CATEGORIES.TOP_FV_AB_TEST,
  action: ACTIONS.CLICK
}

export const EVENT_TITLE_AB_TEST_VIEW = {
  category: CATEGORIES.EVENT_TITLE_AB_TEST,
  action: ACTIONS.VIEW
}
export const EVENT_TITLE_AB_TEST_TICKET_CLICK = {
  category: CATEGORIES.EVENT_TITLE_AB_TEST,
  action: ACTIONS.CLICK
}
export const REPEAT_DISCOUNT_ISSUE_333_VIEW = {
  category: CATEGORIES.REPEAT_DISCOUNT_ISSUE_333,
  action: ACTIONS.VIEW
}
export const REPEAT_DISCOUNT_ISSUE_333_PURCHASE = {
  category: CATEGORIES.REPEAT_DISCOUNT_ISSUE_333,
  action: ACTIONS.PURCHASE
}
export const REPEAT_DISCOUNT_ISSUE_333_MULTIPLE_PURCHASE = {
  category: CATEGORIES.REPEAT_DISCOUNT_ISSUE_333_MULTIPLE,
  action: ACTIONS.PURCHASE
}
export const REPEAT_DISCOUNT_ISSUE_333_REFUND = {
  category: CATEGORIES.REPEAT_DISCOUNT_ISSUE_333_REFUND,
  action: ACTIONS.CANCEL
}

// issue390: エリアトップバナーABテスト用イベント
export const ISSUE_390_VIEW = {
  category: 'issue390',
  action: ACTIONS.VIEW
}

export const ISSUE_390_CLICK = {
  category: 'issue390',
  action: ACTIONS.CLICK
}

// issue-434: ai_recommend_v3 ABテスト用イベント
export const ISSUE_434_SESSION_START = {
  category: 'issue434',
  action: 'session_start'
}

export const ISSUE_434_LIST_VIEW = {
  category: 'issue434',
  action: 'list_view'
}

export const ISSUE_434_DETAIL_VIEW = {
  category: 'issue434',
  action: 'detail_view'
}
